import { twitchService } from '../lib/twitch';

class InitialTokenValidation {
  private static instance: InitialTokenValidation;

  private constructor() {}

  public static getInstance(): InitialTokenValidation {
    if (!InitialTokenValidation.instance) {
      InitialTokenValidation.instance = new InitialTokenValidation();
    }
    return InitialTokenValidation.instance;
  }

  public async validateInitialToken(): Promise<void> {
    try {
      const token = localStorage.getItem('twitch_access_token');
      const refreshToken = localStorage.getItem('twitch_refresh_token');
      
      if (!token || !refreshToken) {
        console.log("Initial validation: No tokens found, logging out");
        twitchService.logout();
        return;
      }

      const fresh = await twitchService.ensureAccessTokenFresh();
      if (!fresh) {
        console.log("Initial validation: Session expired, logging out");
        twitchService.logout();
        return;
      }

      const isValid = await twitchService.validateScopes();
      if (!isValid) {
        console.log("Initial validation: Invalid scopes after refresh, logging out");
        twitchService.logout();
        return;
      }

    } catch (error) {
      console.error('Initial token validation error:', error);
      if (error instanceof Error && error.message.includes('401')) {
        console.log("Initial validation: 401 error, attempting refresh");
        try {
          const refreshed = await twitchService.refreshToken();
          if (!refreshed) {
            console.log("Initial validation: Refresh after 401 failed, logging out");
            twitchService.logout();
          }
        } catch (refreshError) {
          console.error('Initial validation: Refresh attempt failed:', refreshError);
          twitchService.logout();
        }
      } else {
        twitchService.logout();
      }
    }
  }
}

export const initialTokenValidation = InitialTokenValidation.getInstance(); 